import React, { FC, useState } from 'react';
import { Icons } from '@components/Icon';
import useTranslation from '@hooks/useTranslation';
import Title, { TitleTagTypes } from '@ui/SectionTitle/Title';
import ContentWrapper from '../../ui/Content/Content';
import {
    Transportation,
    TransportationDescription,
    TransportationHeader,
    TransportationHeaderIcon,
    TransportationHeaderTitle,
    TransportationOption,
    TransportationOptions,
} from './CompanyCoursesAreas.elements';

enum AREAS {
    MANAGEMENT = 'management',
    SHOP = 'shop',
    DEVELOPMENT_SHOP = 'developmentShop',
    DEVELOPMENT_PERSON = 'developmentPerson',
    FINANCIAL_MANAGEMENT = 'financialManagement',
    HR = 'hr',
    EDUCATION = 'education',
    MARKETING_STRATEGY = 'marketingStrategy',
    TRENDS = 'trends',
    EDI = 'edi',
}

interface CompanyCoursesAreasProps {}

const CompanyCoursesAreasTemplate: FC<CompanyCoursesAreasProps> = () => {
    const { t } = useTranslation();

    const [openedAreas, setOpenedAreas] = useState([]);

    const toggleTransportationOption = (option: AREAS) => {
        openedAreas.includes(option) ? setOpenedAreas([]) : setOpenedAreas([option]);
    };

    return (
        <ContentWrapper mobileSidePadding={20}>
            <Transportation>
                <Title tagType={TitleTagTypes.H3} alignLeft isBlack>
                    <span dangerouslySetInnerHTML={{ __html: t('companyCourses.areas.title') }} />
                </Title>
                <TransportationOptions>
                    {Object.values(AREAS).map((area, key) => (
                        <TransportationOption key={key}>
                            <TransportationHeader onClick={() => toggleTransportationOption(area)}>
                                <TransportationHeaderTitle>
                                    {t(`companyCourses.areas.${area}.label`)}
                                </TransportationHeaderTitle>
                                <TransportationHeaderIcon
                                    className={openedAreas.includes(area) ? 'isOpen' : 'isClose'}
                                    name={Icons.ArrowDown}
                                />
                            </TransportationHeader>
                            {openedAreas.includes(area) && (
                                <TransportationDescription>
                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html: t(`companyCourses.areas.${area}.description`),
                                        }}
                                    />
                                </TransportationDescription>
                            )}
                        </TransportationOption>
                    ))}
                </TransportationOptions>
            </Transportation>
        </ContentWrapper>
    );
};
export default CompanyCoursesAreasTemplate;
